import {connect} from 'react-redux';
import EntryRosterFormVirtualEntriesToModify from './EntryRosterFormVirtualEntriesToModify.jsx'; 

const mapStateToProps = state => ({ 
    virtualEntriesToModify: state.admin.entryDetail.virtualEntriesToModify,
    captainFirstName: String(state.admin.entryDetail.captain.captainFirstName),
    captainLastName: String(state.admin.entryDetail.captain.captainLastName) 
});

const mapDispatchToProps = () => ({ 
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryRosterFormVirtualEntriesToModify);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryRosterFormVirtualEntriesToModifyContainer.jsx